import {  Component, ElementRef, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Store } from "@ngxs/store";

import { Answerable, ButtonAction, HuddyCompass, Question, Wizard, HealthMeasuresAnswer, HealthMeasuresAssessment, HealthMeasuresQuestion, CommonService, ScoredSubscription, AssessmentService, HealthMeasuresService, AnswerType, GetGuidanceSubs } from "huddyapi";


@Component({
  selector: 'assessment-dialog',
  templateUrl: './assessment.html',
  styleUrls: ['./assessment.scss']
})
export class Assessment {
  stateMachineName: string;
  guidanceSubscriptionId: number;
  formOID: string;
  wizard: Wizard;
  currentQuestion : number;
  answers : Map<number, string> = new Map();
  healthMeasuresAssessment: HealthMeasuresAssessment;
  promisLoaded : boolean;
  @ViewChild('measurementCanvas', { static: true }) measurementCanvas : ElementRef;
  screenWidth : number;



  constructor(
    public dialogRef: MatDialogRef<Assessment>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private store : Store,
    private common : CommonService,
    private assessmentService : AssessmentService,
    private promisService : HealthMeasuresService

  ) {
    this.initialize();
  }


  initialize() {
    console.log( 'Compass','about to enter assessment');
     
      this.stateMachineName = this.data.subscription.stateMachineName;
      this.guidanceSubscriptionId =this.data.subscription.guidanceSubscriptionId;
      let promisFormOID : string = this.data.subscription.promisFormOID;
      const subscription : ScoredSubscription = this.data.subscription;
      this.promisLoaded = false;
      if (promisFormOID) {
        this.formOID = promisFormOID;
        
        this.healthMeasuresAssessment = {
          formOID : promisFormOID,
          guidanceSubscriptionId: subscription.guidanceSubscriptionId,
          compassId: subscription.compassId
        };
        this.initializePromis();
      }
      
      this.currentQuestion = -1; 
      console.log('initialize()', this.stateMachineName,  this.formOID, this.guidanceSubscriptionId, this.guidanceSubscriptionId );
  
     
     this.getWizard();

  }

  initializePromis() {
    console.log( 'Compass', 'calling promis', this.healthMeasuresAssessment);
    
    let answerable : Answerable = new Answerable();
    answerable.intro = 'You are all finished!';
    answerable.questions = [];
    answerable.showPreviousAnswers = false;

    this.wizard  = new Wizard();
    this.wizard.answerable = answerable;
    this.healthMeasuresAssessment.guidanceSubscriptionId = this.guidanceSubscriptionId;
    this.doPromisNextQuestion();
  }


  getWizard() {
   this.assessmentService.getWizardForStatemachineName(this.stateMachineName).subscribe(w => {
      console.log('got wizard', w);
      this.wizard = Wizard.clone(w);
      this.setToQuestion(0);
   })
  }

  isPromis()  {
    return this.healthMeasuresAssessment;
  }


  setQuestionNum(n : number) {
    console.log( 'Compass', ' setQuestionNum -setting to ' + n, this.getQuestions(), this.healthMeasuresAssessment, this.currentQuestion, this.isEnd(), this.answers.size);
    if (n > -1 && (n < this.getQuestions().length || this.answers.size === this.getQuestions().length)) {
      this.currentQuestion = n;
    }
  }

  getQuestions() : Question[] {
    if (!this.wizard || !this.wizard.answerable || !this.wizard.answerable.questions) {
      return [];
    }
    return this.wizard.answerable.questions;
  }

  shouldFill(n : number) : boolean {
    return n < this.currentQuestion+1;
  }


  getQuestionText() {
    const questions = this.getQuestions();
    if (!questions || questions.length <= this.currentQuestion) {
      return '';
    }
    const text : string = questions[this.currentQuestion].text;
    return text;
  }



  isEnd() : boolean {
    return (!this.healthMeasuresAssessment || !this.healthMeasuresAssessment.assessmentQuestion) && this.currentQuestion >= this.getQuestions().length;
  }


  doAnswer(answer : string) {
    const question : Question = this.getQuestions()[this.currentQuestion];
    console.log('Compass', 'Entering doAnswer', answer, this.answers, question.useTrackableGuidance);
   
    let current : string = answer;
    if (question.useTrackableGuidance) {
      let current : string = '';
      if (this.answers.has(this.currentQuestion)) {
          current = this.answers.get(this.currentQuestion);
      }

      let arr = current.split("^");
      let idx : number = arr.indexOf(answer);
      if (idx > -1) {
        arr.splice(idx, 1);
        current = arr.join("^");
      } else {
          current = current + '^' + answer;
      }
      this.answers.set(this.currentQuestion,current);
    } else {
      this.answers.set(this.currentQuestion,current);
    }
    console.log( 'Compass', 'doAnswer', this.currentQuestion, answer, this.answers, this.isSelected(answer));
    if (this.isPromis()) {
      this.doPromisNextQuestion(answer);
    } else if (!question.useTrackableGuidance) {
      this.setToQuestion(this.currentQuestion + 1);
    }
    
  }
  saveAssessment() {
    console.log('Entering saveAssessment', this.answers);
    let lastUpdated : string = new Date().toISOString();
    let data = new Map();
    data['_lastUpdated'] = lastUpdated;
    this.answers.forEach((value, key, map) => {
      let sKey = ''+key;
      data[sKey] = value;
    });
    let compass : HuddyCompass =  new HuddyCompass();
    compass.key =  this.stateMachineName;
    compass.username = this.data.subscription.subjectUsername;
    compass.subscriptionId = this.guidanceSubscriptionId;
    compass.questions =   this.getQuestions().map(q => q.text);
    compass.data = data;

    this.assessmentService.saveAssessment(compass).subscribe(response => {
      this.getGuidanceSubs();
      this.close();
  });

    
  }

  getGuidanceSubs() {
    let action = this.data.familyId ? new GetGuidanceSubs(true, false, undefined, this.data.familyId)
      :new GetGuidanceSubs(true, false, this.data.patientId);
    
    console.log('Firing get guidance subs', action);
    this.store.dispatch(action);
  }

  isSelected(answer : string) {
      let ret = false;
      if (this.answers.has(this.currentQuestion)) {
          let result : string = this.answers.get(this.currentQuestion);
          const question : Question = this.getQuestions()[this.currentQuestion];
          if (question.useTrackableGuidance) {
              let answers = result.split("^");
             
              ret = answers.indexOf(answer) > -1;
          } else {
              ret = (result === answer);
          }
      }
      return ret;
  }


  setToQuestion(n : number) {
      this.setQuestionNum(n);
      if (this.isEnd()) {
        this.saveAssessment();
      }
  }

  goBack() {
    this.close();
  }

  isPromisLoaded() : boolean{
    return !this.formOID || this.promisLoaded;
  }

  getQuestionClass() : string {
    // const questions = this.getQuestions();
    // if (!questions || questions.length <= this.currentQuestion) {
    //   return 'question';
    // }
    // const question : Question = this.getQuestions()[this.currentQuestion];
    // const len = question.text.length;
    // if (len > 50) {
    //   return 'question-small';
    // } else if (len < 7 ) {
    //   return 'question-large';
    // } 
    return 'question';  
  }

  getPanelClass() : string {
    const questions = this.getQuestions();
    if (!questions || questions.length <= this.currentQuestion) {
      return 'question-panel';
    }
    const question : Question = this.getQuestions()[this.currentQuestion];
    if (!question || !question.text) {
      return 'question-panel';
    }
    const len = question.text.length;
    if (len > 50) {
      return 'big-question-panel';
    } else if (len < 7 ) {
      return 'small-question-panel';
    } 
    return 'question-panel';  
  }


  getHeaderWordCount(words : string[]) {
    const PADDING : number= 32;
    const ERROR : number = 48;

    const viewportWidth : number =  this.screenWidth;
    let viewportFactor : number = 1;
    if (viewportWidth > 681 && viewportWidth < 1000) {
      viewportFactor = .8;
    }else if (viewportWidth > 999) {
      viewportFactor = .6;
    }

    const viewWidth = (viewportWidth * viewportFactor) - PADDING - ERROR;
    // re-use canvas object for better performance
    const ctx = this.measurementCanvas.nativeElement.getContext("2d");
    ctx.font = "600 48px 'Roboto, Helvetica Neue, sans-serif'";
    let ret : number = 0;
    let accumulated : string = '';
    for (let word of words) {
      accumulated = accumulated + word + ' ';
      
      const metrics = ctx.measureText(accumulated);
      // console.log('text=' + accumulated + ' width=' + metrics.width + " viewPort=" + viewportWidth + " viewWidth=" + viewWidth + ' font-size=' + ctx.font + ' screenwdith=' + this.screenWidth);

      if (metrics.width > viewWidth) {
        break;
      }
      ret++
    }
    return ret;
  }
  

   close() {
    this.dialogRef.close();
   }

  doPromisNextQuestion(answer? : string) {
    if (answer && this.healthMeasuresAssessment.assessmentQuestion.answers) {
      let a : HealthMeasuresAnswer[] = this.healthMeasuresAssessment.assessmentQuestion.answers
            .filter(item => item.answer === answer);
      if (a.length > 0) {
        this.healthMeasuresAssessment.itemOID = a[0].itemOID;
        this.healthMeasuresAssessment.position = a[0].position;
      }      
    }

    this.promisService.getNextQuestion(this.healthMeasuresAssessment).subscribe((t: HealthMeasuresAssessment) => {
      this.healthMeasuresAssessment = t;
      if (this.healthMeasuresAssessment.assessmentQuestion) {
        let source : HealthMeasuresQuestion = this.healthMeasuresAssessment.assessmentQuestion;
        const sanitized = source.question.replace(/<\/?[^>]+(>|$)/g, "");
        console.log('got promis response,', source, sanitized, this.isPromisLoaded());
     
        let q : Question = new Question();
        q.text= sanitized;
        q.logForText = sanitized;
        q.useTrackableGuidance = false;
        q.answerType =  AnswerType['button'];
        q.answers = [].concat(source.answers.map((a : HealthMeasuresAnswer) => { 
            const button : ButtonAction =  new ButtonAction();
            button.button = a.answer;
          return button;
        }));

        if (!this.isPromisLoaded()) {
          this.wizard.answerable.questions = this.wizard.answerable.questions.slice(0, this.wizard.answerable.questions.length - 1);
        }
        this.wizard.answerable.questions.push(q);
        this.promisLoaded = true;
       
        this.setToQuestion(this.currentQuestion+ 1);
        console.log('promis', 'question', this.wizard, q, sanitized.length, this.getQuestionClass());
        
      } else {
        this.setToQuestion(this.currentQuestion + 1);
      }

    
    }); 
  }
  
}